import { SeoMapper } from '@search/router/src';

export const layoutImageMapper = new SeoMapper('layoutImageMapper', {
    HAS_ANY: 'HAS_ANY',
    UNKNOWN: 'UNKNOWN'
} as const);
